// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-canvas[data-v-47ac26ee]{height:38px}.s-canvas canvas[data-v-47ac26ee]{margin-top:5px;margin-left:8px}", ""]);
// Exports
module.exports = exports;
